// extracted by mini-css-extract-plugin
export var option = "_co-0";
export var optionCard = "_co-f";
export var optionContent = "_co-g";
export var optionIcon = "_co-i";
export var optionIconBox = "_co-h";
export var optionLabel = "_co-j";
export var optionPill = "_co-m";
export var optionPillBadge = "_co-p";
export var optionPillIcon = "_co-n";
export var optionPillLabel = "_co-o";
export var optionRadio = "_co-k";
export var optionRadioInner = "_co-l";
export var optionReveal = "_co-2";
export var optionRevealDelay0 = "_co-3";
export var optionRevealDelay1 = "_co-4";
export var optionRevealDelay10 = "_co-d";
export var optionRevealDelay11 = "_co-e";
export var optionRevealDelay2 = "_co-5";
export var optionRevealDelay3 = "_co-6";
export var optionRevealDelay4 = "_co-7";
export var optionRevealDelay5 = "_co-8";
export var optionRevealDelay6 = "_co-9";
export var optionRevealDelay7 = "_co-a";
export var optionRevealDelay8 = "_co-b";
export var optionRevealDelay9 = "_co-c";
export var optionSelected = "_co-1";